module.exports = {"pathContext":{"name":"StockTransferRequestItemFulfillmentStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"COLLECTED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DRAFT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"PARTIAL"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"READY"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-stock-transfer-request-item-fulfillment-status.json
// module id = 1315
// module chunks = 38086154558686